<template>
  <label class="checkbox flex" :class="className">
    <input type="checkbox" v-model="mutableValue">
    <div class="label"><span class="material-icons mr-2" :class="value ? 'text-secondary' : 'text-gray-500'">
      {{value ? 'check_box' : 'check_box_outline_blank' }}</span><span class="font-bold">{{ label }}</span>
    </div>
  </label>
</template>

<style lang="sass" scoped>
label.checkbox
  ::v-deep
    input
      @apply hidden
    .label
      @apply cursor-pointer bg-gray-200 rounded-full text-sm leading-none mb-3 flex items-center justify-center
      input:checked + &
        @apply bg-secondary text-white
      .material-icons
        font-size: 24px
        line-height: 24px

</style>

<script>
export default {
  props: {
    value: { type: Boolean, default: null },
    label: { type: String, required: true },
    className: { type: String, default: ''}
  },
  computed: {
    mutableValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('update:value', v);
      }
    }
  }
}
</script>
